export enum MediaSDKMediaType {
  MICROPHONECAMERA_AUDIO = 'microphoneCamera_audio',
  MICROPHONECAMERA_VIDEO = 'microphoneCamera_video',
  SCREENSHARING_VIDEO = 'screenSharing_video',
  SCREENSHARING_AUDIO = 'screenSharing_audio',
}

export enum MediaSDKDeviceType {
  AUDIO_INPUT = 'audioinput',
  AUDIO_OUTPUT = 'audiooutput',
  VIDEO_INPUT = 'videoinput',
}

export enum PermissionName {
  CAMERA = 'camera',
  MICROPHONE = 'microphone',
}

export enum PermissionStatusState {
  GRANTED = 'granted',
  DENIED = 'denied',
  PROMPT = 'prompt',
}

export type MediaSDKDevices = Record<MediaSDKDeviceType, MediaDeviceInfo[]>;
